export const SKY_PRIORITY = 'SKY_PRIORITY'
export const CHECKED_BAGGAGE = 'CHECKED_BAGGAGE'
